// Curated RONA Workshop DIY projects.
// Source hub: https://www.rona.ca/en/workshop?project-type=diy
// When a user describes a project, we surface matching RONA Workshop guides.
export type RonaProject = {
  id: string
  title: string
  blurb: string
  keywords: string[]
  url: string
}

const WORKSHOP_HUB = 'https://www.rona.ca/en/workshop?project-type=diy'

export const ronaProjects: RonaProject[] = [
  {
    id: 'deck',
    title: 'How to Build a Deck',
    blurb: 'Footings, framing, decking boards, railings & stairs.',
    keywords: ['deck', 'patio', 'decking', 'porch'],
    url: WORKSHOP_HUB,
  },
  {
    id: 'fence',
    title: 'How to Build a Fence',
    blurb: 'Set posts, attach rails and pickets for privacy.',
    keywords: ['fence', 'fencing', 'privacy', 'gate'],
    url: WORKSHOP_HUB,
  },
  {
    id: 'paint-room',
    title: 'How to Paint a Room',
    blurb: 'Prep, prime, cut in and roll for a flawless finish.',
    keywords: ['paint', 'painting', 'wall', 'walls', 'room', 'primer'],
    url: WORKSHOP_HUB,
  },
  {
    id: 'shelving',
    title: 'How to Install Shelving',
    blurb: 'Mount sturdy, level shelves for any room.',
    keywords: ['shelf', 'shelves', 'shelving', 'storage', 'closet'],
    url: WORKSHOP_HUB,
  },
  {
    id: 'garden-bed',
    title: 'How to Build a Raised Garden Bed',
    blurb: 'Frame, line and fill a raised bed for planting.',
    keywords: [
      'garden',
      'planter',
      'raised bed',
      'vegetable',
      'flower',
      'landscaping',
    ],
    url: WORKSHOP_HUB,
  },
  {
    id: 'tile',
    title: 'How to Lay Floor Tile',
    blurb: 'Layout, thinset, set tile and grout like a pro.',
    keywords: ['tile', 'tiles', 'tiling', 'flooring', 'backsplash', 'grout'],
    url: WORKSHOP_HUB,
  },
  {
    id: 'faucet',
    title: 'How to Replace a Faucet',
    blurb: 'Shut off, swap the faucet and seal the connections.',
    keywords: ['faucet', 'sink', 'tap', 'plumbing', 'kitchen'],
    url: WORKSHOP_HUB,
  },
  {
    id: 'shed',
    title: 'How to Build a Storage Shed',
    blurb: 'Foundation, framing, roofing and siding basics.',
    keywords: ['shed', 'storage building', 'workshop', 'outbuilding'],
    url: WORKSHOP_HUB,
  },
  {
    id: 'lighting',
    title: 'How to Install a Light Fixture',
    blurb: 'Safely wire and mount a new fixture.',
    keywords: ['light', 'lighting', 'fixture', 'electrical', 'lamp'],
    url: WORKSHOP_HUB,
  },
  {
    id: 'door',
    title: 'How to Install an Interior Door',
    blurb: 'Hang and trim a pre-hung door square and level.',
    keywords: ['door', 'doorway', 'hinges'],
    url: WORKSHOP_HUB,
  },
]

// Returns RONA projects whose keywords appear in the supplied text.
export function matchRonaProjects(text: string, limit = 3): RonaProject[] {
  if (!text) return []
  const haystack = text.toLowerCase()
  return ronaProjects
    .filter((p) => p.keywords.some((k) => haystack.includes(k)))
    .slice(0, limit)
}
